import ACTIONS from "./types";

export const setLanguage = (lang) => (dispatch) => {
    dispatch({
        type: ACTIONS.SET_LANGUAGE,
        payload: lang
    });
};